import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Avatar from "@material-ui/core/Avatar";

const useStyles = makeStyles((theme) => ({
  productItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(1),
    borderBottom: "1px solid #f0f0f0",
    "&:last-child": {
      borderBottom: "none",
    },
  },
  productItemText: {
    flex: 1,
    fontSize: "0.9rem",
  },
  productItemDetails: {
    fontSize: "0.85rem",
    color: "#666",
    marginLeft: theme.spacing(1),
  },
  productItemPrice: {
    fontWeight: "bold",
    marginLeft: theme.spacing(1),
  },
}));

export default function ProductItem({ product }) {
  const classes = useStyles();

  const formatProductDisplay = (product) => {
    const name = product.fullname || product.name || "";
    const size = product.size || "";
    const id = product.id || product._id || "";
    // Try to get price from various possible fields
    let price = null;
    if (product.price) {
      price = parseFloat(product.price);
    } else if (product.pricing?.currentPrice) {
      price = parseFloat(product.pricing.currentPrice);
    } else if (product.current_price) {
      price = parseFloat(product.current_price);
    }
    
    return {
      name,
      size,
      id,
      price,
      user_avatar: product.user_avatar || product.user_avatar_url,
    };
  };

  const formatted = formatProductDisplay(product);

  return (
    <div className={classes.productItem}>
      <div className={classes.productItemText}>
        <Typography variant="body2">
          {formatted.name}
        </Typography>
        <Typography
          variant="caption"
          className={classes.productItemDetails}
        >
          {formatted.size} #{formatted.id}
          {formatted.price !== null && (
            <span className={classes.productItemPrice}>
              {" "}
              ${formatted.price.toFixed(2)}
            </span>
          )}
        </Typography>
      </div>
      {formatted.user_avatar && (
        <Avatar
          src={formatted.user_avatar}
          style={{ width: 24, height: 24 }}
        />
      )}
    </div>
  );
}
